<!-- компонент Report: отчет с графиком -->
<template>
	<div v-if="this.$store.state.is_auth">

		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl">
				<div v-show="localErrorMessage !== false" class="alert alert-danger" role="alert">
					{{ localErrorMessage | ftc }}
					<span @click="localErrorMessage = false" class="close" aria-label="close" title="close">×</span>
				</div>
			</transition>
			<!-- ===================================== -->

			<!-- Заголовок -->
			<h4 class="w5-view-header">{{ reportData.title | ftc }}</h4>
			<!-- ===================================== -->

			<!-- графики -->
			<chartLine v-if="lineChartData" :data="lineChartData" :options="lineChartOptions" class="w5-chart-graph" style="height: 250px" />
			<chartPie v-if="pieChartData" :data="pieChartData" :options="pieChartOptions" class="w5-chart-graph" style="height: 250px" />
			<chartBar v-if="tableRows && tableRows.length <= 10 && barChartData" :data="barChartData" :options="barChartOptions" class="w5-chart-graph" style="height: 250px" />
			<chartHorBar v-if="tableRows && tableRows.length > 10 && barChartData" :data="barChartData" :options="horBarChartOptions" class="w5-chart-graph" />

			<!-- фильтры -->
			<div style="margin: 20px 0 0 0">
				<!-- фильтр по периоду -->
				<filterPeriod key="filterPeriod"
					v-if="filtersData.period.active"
					:clearButton="false"
					:valueBegin="filtersData.period.begin"
					:valueEnd="filtersData.period.end"
					:notClose="true"
					style="float: left"
					@input="filterPeriodEvent" />
				<!-- ===================================== -->

				<!-- фильтр по дате -->
				<filterDate key="filterDate"
					v-if="filtersData.date.active"
					:clearButton="false"
					v-model="filtersData.date.value"
					:notClose="true"
					style="float: left"
					@input="filterCommonEvent" />
				<!-- ===================================== -->

				<!-- фильтры-select - в список передаем общий объект, внутри которого задан список -->
				<template v-if="filtersData.select && filtersData.select.length">
					<filterSelect
						v-for="(select, idx) in filtersData.select"
						:list="select"
						:key="'select_filter_' + idx"
						:needAllValue="false"
						:notClose="true"
						:name="select.name"
						style="float: left"
						v-model="select.value"						
						@input="filterCommonEvent" />
				</template>
				<!-- ===================================== -->
			</div>

			<!-- таблица с данными -->
			<div class="report-table-wrapper margin-10-0" :style="id === 'ip' ? 'width: 100%' : false">
			<table v-if="tableHeader && Array.isArray(tableHeader) && tableHeader[0] && Array.isArray(tableHeader[0]) && tableHeader[0].length"
				class="w5-view-field-table report-table"
				:class="{ 'auto-layout': id === 'partneraccount' || id === 'ip', 'small-font': id === 'serverresource' }">
				<colgroup v-if="id === 'serverresource'">
					<col>
					<col>
					<col>
					<col>
					<col>
					<col>
					<col>
					<col style="width:40px">
					<col style="width:40px">
					<col>
					<col>
					<col style="width:40px">
					<col>
					<col>
					<col style="width:40px">
					<col>
					<col>
					<col>
					<col>
					<col>
					<col style="width:40px">
				</colgroup>
				<thead>
					<tr v-if="tableHeader && Array.isArray(tableHeader) && tableHeader[0] && Array.isArray(tableHeader[0]) && tableHeader[0].length">
						<th v-for="(h, idx) in tableHeader[0]"
							:rowspan="h.rowspan > 1 ? h.rowspan : false"
							:colspan="h.colspan > 1 ? h.colspan : false"
							:key="'header-0-' + idx"
							:style="headerStyle0(idx)"
							class="report-header"
							:class="h.rowspan > 1 ? ' sort' : ''"
							@click="sortLocal(0, h, idx)">
							<span>{{ h.title | ftc | rub }}</span>
						</th>
					</tr>
					<tr v-if="tableHeader && Array.isArray(tableHeader) && tableHeader[1] && Array.isArray(tableHeader[1]) && tableHeader[1].length">
						<th v-for="(h, idx) in tableHeader[1]"
							:style="headerStyle1(idx)"
							class="report-header sort"
							:key="'header-1-' + idx"
							@click="sortLocal(1, h, idx)">
							<span>{{ h.title | ftc | rub }}</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="tableRows && tableRows.length">
						<tr v-for="(row, idx) in tableRows" :key="idx" :class="row.alert === true ? 'alert-record' : false">
							<td v-for="(col, nm) in tableColumns"
								:style="cellStyle(row, nm, col, idx)"
								:key="'cell-' + idx + '_' + nm"
								:class="(sortHeaderIndex.colName === nm || sortHeaderIndex.colName === col.field) && sortHeaderIndex.value ? 'w5-table-cell-sorted' : ''">
								<span v-if="('server_view_type' in row) && (nm === 'server' || nm === 'server_name')" :class="'color-type-' + String(row['server_view_type'])" style="font-size: 13px; line-height: 1;">&#9679;</span>
								<linkComponent v-if="'link' in col" :url="linkURL(row, nm, col)" :text="linkText(row, nm, col)" :valueType="col.type" />
								<template v-else>
									<template v-if="col['type'] === 'boolean'">
										<font-awesome-icon v-if="booleanValue(row[nm])" icon="check" style="color: green" />
										<font-awesome-icon v-else icon="times" style="color: red" />
									</template>
									<template v-else>{{ getTableValue(row, nm, col) }}</template>
								</template>
							</td>
						</tr>
						<!-- итоговая строка -->
						<tr v-if="tableItog && Object.keys(tableItog).length" class="w5-chart-table-total">
							<td v-for="(col, nm) in tableColumns" :style="cellStyle(tableItog, nm, col, 'itog')" :key="'itog-' + nm">
								<template v-if="col['type'] === 'boolean'"></template>
								<template v-else>{{ getTableValue(tableItog, nm, col) }}</template>
							</td>
						</tr>
					</template>
					<template v-else>
						<tr class="empty-table-tr">
							<td :colspan="Object.keys(tableColumns).length" class="text-center">
								<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
								<br>
								<span class="w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
			</div>
			<!-- ===================================== -->
			
			<!-- кнопка "Назад" -->
			<div class="w5-field" style="padding-right: 0">
				<button type="button" class="btn btn-default pull-right" :class="{ disabled: form_Loading }" :disable="form_Loading ? 'disabled' : false" @click.stop="backButton">{{ 'main/back' | ftc }}</button>
				<span class="clearfix"></span>
			</div>
			<!-- ===================================== -->

		</template>

		<errorAlert v-else :message="form_ErrorMessage" />

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import filterPeriod from '@/components/widgets/filterPeriod'
import filterDate from '@/components/widgets/filterDate'
import filterSelect from '@/components/widgets/filterSelect'
import chartLine from '@/components/charts/line'
import chartPie from '@/components/charts/pie'
import chartBar from '@/components/charts/bar'
import chartHorBar from '@/components/charts/horbar'
import '@/components/../../node_modules/chart.piecelabel.js/build/Chart.PieceLabel.min'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'Report',
	//=========================================================================
	//
	//=========================================================================
	data() {
		return {
			// данные отчета
			reportData: {
				'title': ' '
			},

			// ID отчета
			id: null,

			// модель отчета
			model: false,

			// локальное сообщение об ошибке
			localErrorMessage: false,

			// фильтры - записывается в localStorage
			filtersData: {
				'period': {
					'active': false,
					'begin': false,
					'end': false,
					'init': false
				},
				'date': {
					'active': false,
					'value': false,
					'init': false
				},
				'select': []
			},

			// заголовок таблицы
			tableHeader: [[], []],
			// колонки таблицы
			tableColumns: {},
			// строки таблицы
			tableRows: [],
			// итоговая строка
			tableItog: {},
			// выделенные колонки
			tableGraphColumns: [],

			// по какой колонке отсортировано - любое отрицательное значение: ни по какой
			sortHeaderIndex: {
				colName: '',
				value: 0
			},

			// цвета
			Colors: [
				'9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333',
				'999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666',
				'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633',
				'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC',

				'9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333',
				'999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666',
				'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633',
				'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC'
			],

			// данные для графика типа "Line"
			lineChartData: false,
			lineChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index'
				},
				'scales': {
					xAxes: [{
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						gridLines: {
							display: true,
							zeroLineColor: '#999'
						},
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function(value) { if (value % 1 === 0) return value }
						}
					}]
				}
			},

			// данные для графика типа "Pie"
			pieChartData: false,
			pieChartOptions: {
				cutoutPercentage: 30,
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: true,
					callbacks: {
						label: function(tooltipItems, data) {
							return ' ' + data['labels'][tooltipItems.index] + ' (' + data['datasets'][0]['data'][tooltipItems.index] + '%)'
						}
					}
				},
				'pieceLabel': {
					fontSize: 11,
					fontFamily: 'Roboto',
					mode: 'percentage',
					precision: 2
				}
			},

			// данные для графика типа "Bar"
			barChartData: false,
			barChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'scales': {
					xAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}],
					yAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function(value) { if (value % 1 === 0) return value }
						}
					}]
				},
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false
				}
			},
			horBarChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'scales': {
					xAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11,
							beginAtZero: true,
							callback: function(value) { if (value % 1 === 0) return value }
						}
					}],
					yAxes: [{
						barPercentage: 0.7,
						ticks: {
							fontSize: this.$store.state.windowWidth < 590 ? 9 : 11
						}
					}]
				},
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false
				}
			}
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// тип пользователя
		UserType() {
			return this.$store.state.user_type
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// теперь можно запросить данные
		this.requestReportData()
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// инициируем основные данные
			this.initData(to.path)

			// теперь можно запросить данные
			this.requestReportData()
		}
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.id = null
			this.localErrorMessage = false

			// скрываем по умолчанию все фильтры
			this.hideFilters()

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должны быть минимум три части
			if (_urlParts.length < 3 ||
				!_urlParts[0] || !_urlParts[0].length ||
				!_urlParts[1] || !_urlParts[1].length ||
				_urlParts[2] === null || _urlParts[2] === undefined || _urlParts[2] === '')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если первая часть это не "chart"
			if (_urlParts[0] !== 'chart')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если вторая часть это не "view"
			if (_urlParts[1] !== 'view')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим ID объекта, мы не приводим к INT, так как бывают ID строковые
			this.id = _urlParts[2]
		},
		//---------------------------------------------------------------------
		// сокрытие всех фильтров
		//---------------------------------------------------------------------
		hideFilters() {
			this.filtersData.period.active = false
			this.filtersData.date.active = false

			if (this.filtersData.select && this.filtersData.select.length)
			{
				this.filtersData.select.forEach(s => {
					s.active = false
				})
			}
		},
		//---------------------------------------------------------------------
		// инициализация всех фильтров полученными данными
		//---------------------------------------------------------------------
		initFiltersByData(data, storageKey) {
			// проверка
			if (!data['filters'] || typeof data['filters'] !== 'object') return

			// бежим по всем фильтрам
			for (let filterName in data['filters'])
			{
				// текущий фильтр
				let filter = data['filters'][filterName]

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// если это фильтр с датами
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				if (filter['type'] === 'date')
				{
					let _val = String(filter['value'])

					// фильтр по дате
					if (filterName === 'date')
					{
						this.filtersData.date.active = filter['showif'] === undefined || filter['showif'] === null
						this.filtersData.date.showif = filter['showif']
						this.filtersData.date.value = null
						this.filtersData.date.name = filterName
						this.filtersData.date.init = true

						if (/^\d{4}-\d{2}-\d{2}$/.test(_val))
						{
							this.filtersData.date.value = _val
						}
					}
					else if (filterName.indexOf('_start') > -1)
					{
						this.filtersData.period.active = filter['showif'] === undefined || filter['showif'] === null
						if (!this.filtersData.period.showif)
						{
							this.filtersData.period.showif = {}
						}
						this.filtersData.period.showif.start = filter['showif']
						this.filtersData.period.begin = false
						this.filtersData.period.name = filterName.replace('_start', '')
						this.filtersData.period.init = true

						if (/^\d{4}-\d{2}-\d{2}$/.test(_val))
						{
							this.filtersData.period.begin = _val + ' 00:00:00'
						}
						else if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val))
						{
							this.filtersData.period.begin = _val
						}
					}
					else if (filterName.indexOf('_end') > -1)
					{
						this.filtersData.period.active = filter['showif'] === undefined || filter['showif'] === null
						if (!this.filtersData.period.showif)
						{
							this.filtersData.period.showif = {}
						}
						this.filtersData.period.showif.end = filter['showif']
						this.filtersData.period.end = false
						this.filtersData.period.name = filterName.replace('_end', '')
						this.filtersData.period.init = true

						if (/^\d{4}-\d{2}-\d{2}$/.test(_val))
						{
							this.filtersData.period.end = _val + ' 23:59:59'
						}
						else if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val))
						{
							this.filtersData.period.end = _val
						}
					}
				}
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// фильтр select
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				else if (filter['type'] === 'list' && filter['list'])
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ищем данный фильтр в списке
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					let _foundFilter = null
					if (this.filtersData.select && this.filtersData.select.length)
					{
						this.filtersData.select.some(select => {
							if (select && select.name === filterName)
							{
								_foundFilter = select
								return true
							}
						})
					}

					// если еще не нашли в текущем списке фильтров
					if (!_foundFilter)
					{
						_foundFilter = {
							'active': filter['showif'] === undefined || filter['showif'] === null,
							// нормализовывать список не нужно - это сделает сам компонент "filterSelect"
							'list': filter['list'],
							'name': filterName,
							'showif': filter['showif'],
							'default': filter['default'],
							'value': false
						}

						// добавляем в список
						if (!this.filtersData.select || !this.filtersData.select.length)
						{
							this.filtersData.select = []
						}
						this.filtersData.select.push(_foundFilter)
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// определим значение
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					let _val = filter['value']
					let _isNeedAllRecord = false

					// если есть значение по умолчанию
					if ('default' in filter)
					{
						// и если значение фильтра еще не установлено
						if (_val === undefined || _val === null || _val === '')
						{
							if (Array.isArray(filter['list']))
							{
								let _found = filter['list'].some(item => {
									if (item && String(item.id) === String(filter['default']))
									{
										_val = item.id
										return true
									}
								})

								if (!_found)
								{
									// в "default" записано несуществующее значение - нужен элемент "все"
									_isNeedAllRecord = true
									_val = -1
								}
							}
							else
							{
								let _found = false
								for (let l in filter['list'])
								{
									if (String(l) === String(filter['default']))
									{
										_val = l
										_found = true
										break
									}
								}

								if (!_found)
								{
									// в "default" записано несуществующее значение - нужен элемент "все"
									_isNeedAllRecord = true
									_val = -1
								}
							}
						}
					}
					else
					{
						// значения по умолчанию нет - нужен элемент "все"
						_isNeedAllRecord = true
					}

					// если требуется вставить в список элемент "все"
					if (_isNeedAllRecord)
					{
						// значения по умолчанию нет - значит нужно значение "все"
						if (Array.isArray(_foundFilter.list))
						{
							// ищем значение "все" - может уже добавлено
							let _all = _foundFilter.list.some(item => {
								if (String(item.id) === '-1')
								{
									return true
								}
							})

							// если так и не нашли
							if (!_all)
							{
								// добавим
								_foundFilter.list.unshift({ 'id': -1, 'name': this.localeFtc('main/list_all') })
							}
						}
						else
						{
							// если в объекте списка еще нет
							if (!_foundFilter.list['-1'])
							{
								// добавим
								_foundFilter.list['-1'] = this.localeFtc('main/list_all')
							}
						}

						// и если значение фильтра еще не установлено - тогда будет значение "все"
						if (_val === undefined || _val === null || _val === '')
						{
							_val = -1
						}
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// поиск и установка значения модели
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (Array.isArray(_foundFilter.list))
					{
						_foundFilter.list.some((item) => {
							if (item && String(item['id']) === String(_val))
							{
								_foundFilter.value = {
									'id': String(item['id']),
									'name': this.localeFtc(item['name'])
								}
								return true
							}
						})
					}
					else
					{
						for (let l in _foundFilter.list)
						{
							if (String(l) === String(_val))
							{
								_foundFilter.value = {
									'id': l,
									'name': this.localeFtc(_foundFilter.list[l])
								}
								break
							}
						}
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}

			// запоминаем фильтры и модель в sesionStorage
			if (window.sessionStorage)
			{
				window.sessionStorage.setItem(storageKey, JSON.stringify({
					'model': this.model,
					'filters': this.filtersData
				}))
			}

			// рассчитываем "showif"
			this.showifFilters()
		},
		//---------------------------------------------------------------------
		// формирует выражение для "showif"
		//---------------------------------------------------------------------
		makeExpression(showif) {
			// получим выражение в виде строки
			let _expr = showif

			// если это выражение типа:
			// var in [array]
			// или
			// var not in [array]
			if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
			{
				// условие: var not in [array]
				if (_expr.indexOf(' not in ') !== -1)
				{
					// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
					let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

					// проверяем
					if (reg.exec(_expr) !== null)
					{
						_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
					}
					else
					{
						// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
						reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
						let _mtch = null
						if ((_mtch = reg.exec(_expr)) !== null)
						{
							_expr = _expr.replace(_mtch[0], 'w5InArray(' +
								_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
								', ' +
								_mtch[2] +
								') < 0')
						}
					}
				}
				// условие: var in [array]
				else
				{
					// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
					let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

					// проверяем
					if (reg.exec(_expr) !== null)
					{
						_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
					}
					else
					{
						// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
						reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
						let _mtch = null
						if ((_mtch = reg.exec(_expr)) !== null)
						{
							_expr = _expr.replace(_mtch[0], 'w5InArray(' +
								_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
								', ' +
								_mtch[2] +
								') !== -1')
						}
					}
				}
			}
			// type[period] == 0    =>    type__period__ == 0
			else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')

			return _expr
		},
		//---------------------------------------------------------------------
		// инициализация всех фильтров полученными данными
		//---------------------------------------------------------------------
		findFilter(filterName) {
			if (this.filtersData.date.name === filterName)
			{
				return this.filtersData.date
			}

			if (String(this.filtersData.period.name) + '_start' === filterName ||
				String(this.filtersData.period.name) + '_end' === filterName)
			{
				return this.filtersData.period
			}

			if (this.filtersData.select && this.filtersData.select.length)
			{
				let _answer = null
				this.filtersData.select.some(select => {
					if (select.name === filterName)
					{
						_answer = select
						return true
					}
				})

				if (_answer) return _answer
			}

			return null
		},
		//---------------------------------------------------------------------
		// расчет видимости фильтров на основе полей "showif"
		//---------------------------------------------------------------------
		showifFilters() {
			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}
			let _yes = false

			// date
			if (this.filtersData.date.init)
			{
				_values[String(this.filtersData.date.name).replace(/\[/g, '__').replace(/]/g, '__')] = this.filtersData.date.value

				if (this.filtersData.date.showif)
				{
					_yes = true
					_expressions[this.filtersData.date.name] = this.makeExpression(this.filtersData.date.showif)
				}
			}

			// period
			if (this.filtersData.period.init)
			{
				_values[(String(this.filtersData.period.name) + '_start').replace(/\[/g, '__').replace(/]/g, '__')] = this.filtersData.period.begin ? this.formater_Date2StrDate(this.filtersData.period.begin) : null
				_values[(String(this.filtersData.period.name) + '_end').replace(/\[/g, '__').replace(/]/g, '__')] = this.filtersData.period.end ? this.formater_Date2StrDate(this.filtersData.period.end) : null

				if (this.filtersData.period.showif && this.filtersData.period.showif.start)
				{
					_yes = true
					_expressions[String(this.filtersData.period.name) + '_start'] = this.makeExpression(this.filtersData.period.showif.start)
				}

				if (this.filtersData.period.showif && this.filtersData.period.showif.end)
				{
					_yes = true
					_expressions[String(this.filtersData.period.name) + '_end'] = this.makeExpression(this.filtersData.period.showif.end)
				}
			}

			// selects
			if (this.filtersData.select && this.filtersData.select.length)
			{
				this.filtersData.select.forEach(select => {
					let _val = null
					if (select.value && 'id' in select.value)
					{
						_val = select.value['id']
					}

					_values[String(select.name).replace(/\[/g, '__').replace(/]/g, '__')] = _val

					if (select.showif)
					{
						_yes = true
						_expressions[select.name] = this.makeExpression(select.showif)
					}
				})
			}

			if (!_yes) return

			// теперь бежим по всем полученным выражениям
			for (let filterName in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[filterName]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _filter = this.findFilter(filterName)
				if (_filter)
				{
					// установим видимость фильтра
					this.$set(_filter, 'active', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// инициализация всех фильтров полученными данными
		//---------------------------------------------------------------------
		setFiltersForRequest() {
			if (!this.id || !this.model) return null

			let _yes = false
			let _filter = {}
			_filter[this.model] = {}

			// если есть фильтр по дате
			if (this.filtersData.date.active)
			{
				_yes = true
				_filter[this.model]['date'] = this.filtersData.date.value ? this.formater_Date2StrDate(this.filtersData.date.value) : null
			}

			// если есть фильтр по периоду
			if (this.filtersData.period.active)
			{
				_yes = true
				_filter[this.model]['date_start'] = this.filtersData.period.begin ? this.formater_Date2StrDate(this.filtersData.period.begin) : null
				_filter[this.model]['date_end'] = this.filtersData.period.end ? this.formater_Date2StrDate(this.filtersData.period.end) : null
			}

			// если есть фильтры-списки
			if (this.filtersData.select && this.filtersData.select.length)
			{
				this.filtersData.select.forEach(select => {
					if (select && select.name && select.active && select.value && select.value['id'] !== '-1')
					{
						_yes = true
						_filter[this.model][select.name] = select.value['id']
					}
				})
			}

			return (_yes ? _filter : null)
		},
		//---------------------------------------------------------------------
		// ключ данных в sessionStorage
		//---------------------------------------------------------------------
		keyOfSessionStoreage() {
			return 'w5_chart_' + (this.id ? this.id : '') + '_' + this.$store.state.user_id
		},
		//---------------------------------------------------------------------
		// получаем данные сохраненные в sessionStorage
		//---------------------------------------------------------------------
		getFromSessionStorage() {
			let key = this.keyOfSessionStoreage()
			let data = window.sessionStorage ? window.sessionStorage.getItem(key) : false

			return {
				key,
				data
			}
		},
		//---------------------------------------------------------------------
		// удалим данные из sessionStorage
		//---------------------------------------------------------------------
		delFromSessionStoreage() {
			let key = this.keyOfSessionStoreage()
			if (window.sessionStorage)
			{
				window.sessionStorage.removeItem(key)
			}
		},
		//---------------------------------------------------------------------
		// запрос данных
		//---------------------------------------------------------------------
		requestReportData() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// готовим URL и ключ в sessionStorage
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = '/chart/view/'
			// ID отчета
			if (this.id) _url += this.id

			// если есть данные в sessionStorage
			let _storage = this.getFromSessionStorage()
			if (_storage.data)
			{
				let _storageData = JSON.parse(_storage.data)
				// разпарсим
				this.filtersData = _storageData['filters']
				this.model = _storageData['model']
				// и сразу удалим
				window.sessionStorage.removeItem(_storage.key)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// готовим параметры фильтра
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _filter = false
			if (this.model)
			{
				_filter = this.setFiltersForRequest()
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// при каждом запросе делаем сброс локальной сортировки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.sortHeaderIndex = {
				colName: '',
				value: 0
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// производим запрос
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.forms_Get(_url, _filter,
				// успешно получили данные
				(data) => {
					// проверим данные
					if (!data || data['status'] !== 'ok' || !data['rows'] || !data['type'])
					{
						// ошибка - некорректные данные
						this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
					}
					else
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// данные пришли - корректные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// данные
						this.reportData = Object.assign({}, data)

						// модель
						this.model = data['model']

						// заголовок таблицы
						this.getTableHeader(data['order'], data['columns'])

						// строки обновляются в следующем тике
						this.tableRows = []
						this.tableItog = {}
						this.tableGraphColumns = []

						this.lineChartData = false
						this.pieChartData = false
						this.barChartData = false

						this.$nextTick(() => {
							this.tableRows = this.reportData['rows']
							// нужно добавить поле для сортировки цветов
							for (let i in this.tableRows)
								this.tableRows[i]['__rowNo'] = parseInt(i, 10)
							this.tableItog = this.reportData['totalRow']
							this.tableGraphColumns = this.reportData['type']['columns']

							// график - Line
							if (this.reportData &&
								this.reportData['rows'] &&
								this.reportData['type'] &&
								this.reportData['type']['abscissa'] &&
								this.reportData['type']['view'] === 'graph')
								this.getLineChartData()

							// график - Pie
							if (this.reportData &&
								this.reportData['rows'] &&
								this.reportData['type'] &&
								this.reportData['type']['columns'] &&
								this.reportData['type']['view'] === 'pie')
								this.getPieChartData()

							// график - Bar
							if (this.reportData &&
								this.reportData['rows'] &&
								this.reportData['type'] &&
								this.reportData['type']['abscissa'] &&
								this.reportData['type']['view'] === 'bar')
								this.getBarChartData()
						})

						// фильтры
						if (data['filters'])
						{
							this.initFiltersByData(data, _storage.key)
						}
					}
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// формирует массив строк - заголовков таблицы
		//---------------------------------------------------------------------
		getTableHeader(order, columns) {
			// обнуляем все
			this.tableHeader = [[], []]
			this.tableColumns = {}

			let idx0 = 0

			// проверка параметров
			if (!order || !Array.isArray(order) ||
				!columns || typeof columns !== 'object')
			{
				if (this.$store.state.isDebug) window.DEBUG.error('Rgth0: неверный формат колонок таблицы')
				return
			}

			// начинаем заполнять заголовок согласно заданному порядку
			for (let o in order)
			{
				// найдем в колонках
				let _col = columns[order[o]]
				if (!_col)
				{
					if (this.$store.state.isDebug) window.DEBUG.error('Rgth1: колонка есть в порядке, но нет в данных о колонках')
					continue
				}

				// собираем информацию о колонке
				let _info = {
					'title': _col['name'] ? this.localeFtc(_col['name']) : this.localeFtc(_col['title']),
					'type': _col['type'],
					'field': order[o]
				}

				// если есть значение и откуда его брать
				// value необязателен
				if (/*'value' in _col && */'from' in _col && 'link' in _col)
				{
					_info['value'] = _col['value']
					_info['from'] = _col['from']
					_info['link'] = _col['link']
					if ('NAME' in _col['from']) _info['field'] = _col['from']['NAME']
				}

				// частный случай
				if (this.id === 'ip' && _col['link'] && !_info['link'])
				{
					_info['link'] = _col['link']
				}

				// сразу запоминаем в колонках и заголовке
				if (_info['type'] !== 'colspan') this.tableColumns[order[o]] = _info
				this.tableHeader[0][idx0] = {
					'title': _info['title'],
					'rowspan': 2,
					'colspan': 1,
					'field': _info['field']
				}

				// если есть подколонки
				if ('columns' in _col)
				{
					// увеличим rowspan и colspan
					this.tableHeader[0][idx0]['rowspan'] = 1
					this.tableHeader[0][idx0]['colspan'] = Object.keys(_col['columns']).length

					// соберем все колонки
					for (let oo in _col['columns'])
					{
						let __col = _col['columns'][oo]
						if (!__col)
						{
							if (this.$store.state.isDebug) window.DEBUG.error('Rgth2: нет в данных о подколонке')
							continue
						}

						// собираем информацию о колонке
						_info = {
							'title': this.localeFtc(__col['title']),
							'type': __col['type'],
							'colspan': 1,
							'field': oo
						}

						// если есть значение и откуда его брать
						// value необязателен
						if (/*'value' in _col && */'from' in __col && 'link' in __col)
						{
							_info['value'] = __col['value']
							_info['from'] = __col['from']
							_info['link'] = __col['link']
						}

						// частный случай
						if (this.id === 'ip' && __col['link'] && !_info['link'])
						{
							_info['link'] = __col['link']
						}

						// запоминаем в колонках и заголовке
						this.tableColumns[oo] = _info
						this.tableHeader[1].push({ title: _info['title'], field: _info['field'] })
					}
				}

				// следующая колонка
				idx0++
			}
		},
		//---------------------------------------------------------------------
		// получает данные для простой ячейки таблицы
		//---------------------------------------------------------------------
		getTableValue(row, colName, colData) {
			// это просто значение
			if (!(colName in row)) return ''

			// integer
			if (colData['type'] === 'integer')
			{
				let _v = parseInt(row[colName])
				if (isNaN(_v)) return '-'
				return _v
			}

			// float
			if (colData['type'] === 'float')
			{
				let _v = parseFloat(row[colName])
				if (isNaN(_v)) return '-'
				return _v.toFixed(2)
			}

			// money
			if (colData['type'] === 'money')
			{
				let _v = parseFloat(row[colName])
				if (isNaN(_v)) return '-'
				return Helper.Money2String(_v, 2, '.', ' ')
			}

			return this.localeFtc(row[colName])
		},
		//---------------------------------------------------------------------
		// получает данные для ячейки-ссылки таблицы
		//---------------------------------------------------------------------
		linkURL(row, colName, colData) {
			// частные случаи
			if (this.id === 'ip')
			{
				if (colData.link && !colData.from) return colData.link
			}

			// если это не ссылка
			if (!('from' in colData) || !('link' in colData) || !('value' in colData)) return ''

			let _href = this.clientRoutePath(colData['link'], row, colName)
			let _hrefField = _href.match(/%(.*?)%/i)
			let _paramName = false
			if (_hrefField !== null && _hrefField.length > 1)
			{
				_hrefField = _hrefField[1]
				_paramName = _hrefField
			}

			if (_hrefField in colData['from']) _hrefField = colData['from'][_hrefField]

			let _hrefValue = _hrefField in row && row[_hrefField] ? row[_hrefField] : false

			return _href.replace('%' + _paramName + '%', _hrefValue)
		},
		//---------------------------------------------------------------------
		// возвращает реальный "клиентский" маршрут
		//---------------------------------------------------------------------
		clientRoutePath(path, row, colName) {
			// список услуг
			let _mask = {
				'additional-services': '/service/list?ServiceSearch[service_type_id]=15',
				'dns': '/service/list?ServiceSearch[service_type_id]=14',
				'certificate': '/service/list?ServiceSearch[service_type_id]=11',
				'vds': '/service/list?ServiceSearch[service_type_id]=1'
			}

			// частные случаи
			if (this.id === 'cephresource' && colName === 'services_server') {
				if (row && String(row['server_type']).indexOf('extdisk_') === 0) {
					return path.replace('/service/list', '/disks/list')
				}
				if (row && String(row['server_type']) === 'backup') {
					return path.replace('/service/list', '/backups/list')
				}
			}

			for (let realPath in _mask)
			{
				// если нашли наш путь
				if (path.indexOf(_mask[realPath]) === 0)
				{
					// определим реальный путь
					let _realPath = realPath
					// частные случаи
					if (this.id === 'cephresource' && realPath === 'additional-services')
						_realPath = 'backups'

					// заменяем
					path = path.replace(_mask[realPath], '')

					// если остался хвост
					if (path)
					{
						if (path[0] === '&') path = '/' + _realPath + '/list?' + path.substring(1)
						else path = '/' + _realPath + '/list?' + path
					}
					else path = '/' + _realPath + '/list'
					return path
				}
			}

			// если ничего не нашли - возвращаем как есть
			return path
		},
		//---------------------------------------------------------------------
		// получает данные для ячейки-ссылки таблицы
		//---------------------------------------------------------------------
		linkText(row, colName, colData) {
			// частные случаи
			if (this.id === 'ip' && colData['link'] && !colData['from'])
			{
				return row[colName]
			}

			// если это не ссылка
			if (!('from' in colData) || !('link' in colData) || !('value' in colData)) return ''

			let _textValue = null
			let _text = colData['value']

			if (_text)
			{
				let _textField = _text.match(/%(.*?)%/i)
				if (_textField !== null && _textField.length > 1) _textField = _textField[1]

				if (_textField in colData['from']) _textField = colData['from'][_textField]

				_textValue = _textField in row ? row[_textField] : null
			}
			else
			{
				_textValue = colName in row ? row[colName] : null
			}

			return _textValue
		},
		//---------------------------------------------------------------------
		// стиль ячейки
		//---------------------------------------------------------------------
		cellStyle(row, colName, colData, rowNo) {
			// по умолчанию шрифт меньше
			let _style = 'font-size: 80%; word-wrap: break-word;'
			if (this.id === 'serverresource') _style = 'font-size: 72%; word-wrap: break-word;'

			// смотрим тип колонки
			if (colData['type'] === 'integer' || colData['type'] === 'float' || colData['type'] === 'money')
				_style += 'text-align: right; overflow: auto; white-space: nowrap;'
			else if (colData['type'] === 'boolean' || colData['type'] === 'date' || colData['type'] === 'datetime')
				_style += 'text-align: center;'

			// разукрасим
			if (rowNo !== 'itog')
			{
				if (this.reportData['type']['view'] !== 'pie')
				{
					// вычисляем индекс
					let _idx = -1
					for (let r in this.tableGraphColumns)
					{
						if (this.tableGraphColumns[r] === colName)
						{
							_idx = r
							break
						}
					}
					// красим
					if (_idx > -1 && this.Colors[_idx]) _style += 'color: #' + this.Colors[_idx] + ';'
				}
				else if (this.tableGraphColumns[0] === colName)
				{
					if ('__rowNo' in row) _style += 'color: #' + this.Colors[row['__rowNo']] + ';'
					else _style += 'color: #' + this.Colors[rowNo] + ';'
				}
			}

			return _style
		},
		//---------------------------------------------------------------------
		// форматирование булевого значения
		//---------------------------------------------------------------------
		booleanValue(value) {
			return Helper.normalizeBooleanValue(value)
		},
		//---------------------------------------------------------------------
		// кнопка "назад"
		//---------------------------------------------------------------------
		backButton() {
			this.$router.go(-1)
		},
		//---------------------------------------------------------------------
		// обработчик измнения фильтра по периоду
		//---------------------------------------------------------------------
		filterPeriodEvent(value) {
			// обнулим данные в sessionStorage
			this.delFromSessionStoreage()
			// запомним значения фильтра
			this.filtersData.period.begin = value['begin'] ? this.formater_Date2StrDate(value['begin']) + ' 00:00:00' : false
			this.filtersData.period.end = value['end'] ? this.formater_Date2StrDate(value['end']) + ' 23:59:59' : false
			// рассчитываем "showif"
			this.showifFilters()
			// запросим данные
			this.requestReportData()
		},
		//---------------------------------------------------------------------
		// обработчик измнения фильтра-select
		//---------------------------------------------------------------------
		filterCommonEvent() {
			// обнулим данные в sessionStorage
			this.delFromSessionStoreage()
			// рассчитываем "showif"
			this.showifFilters()
			// запросим данные
			this.requestReportData()
		},
		//---------------------------------------------------------------------
		// форматирование данных для графика вида "Line"
		//---------------------------------------------------------------------
		getLineChartData() {
			// ось абсцисс
			let _fieldAbscissa = this.reportData['type']['abscissa']
			let _rows = this.reportData['rows']
			let _labels = []
			let _tmp = ''

			let _columns = this.reportData['type']['columns']
			let _sets = []

			// собираем ось
			for (let i in _rows)
			{
				// значение
				_tmp = _rows[i][_fieldAbscissa]
				// запоминаем
				_labels.push(_tmp)
			}

			// наборы данных
			for (let c in _columns)
			{
				// готовим объект - набор данных
				let _obj = {
					fill: false,
					lineTension: 0.05,
					borderWidth: 1
				}
				// наименование поле
				_obj['label'] = this.localeFtc(
					this.tableColumns[_columns[c]] && this.tableColumns[_columns[c]]['title']
						? this.tableColumns[_columns[c]]['title']
						: _columns[c]
				)
				// цвета
				_obj['borderColor'] = '#' + this.Colors[c]
				_obj['backgroundColor'] = '#' + this.Colors[c]
				_obj['pointBackgroundColor'] = '#' + this.Colors[c]
				// данные
				_obj['data'] = []
				for (let i in _rows)
				{
					// значение
					_tmp = _rows[i][_columns[c]]
					// конвертация значения
					if (this.tableColumns && this.tableColumns[_columns[c]])
					{
						if (this.tableColumns[_columns[c]]['type'] === 'integer') _tmp = parseInt(_tmp)
						else if (this.tableColumns[_columns[c]]['type'] === 'float' || this.tableColumns[_columns[c]]['type'] === 'money') _tmp = parseFloat(_tmp)
					}
					// запоминаем
					_obj['data'].push(_tmp)
				}

				// добавляем набор данных в сет
				_sets.push(_obj)
			}

			this.lineChartData = {
				'labels': _labels
			}
			this.lineChartData['datasets'] = _sets
		},
		//---------------------------------------------------------------------
		// форматирование данных для графика вида "Pie"
		//---------------------------------------------------------------------
		getPieChartData() {
			// для пирогов - только одно поле
			let _field = this.reportData['type']['columns'][0]
			// начинаем собирать данные
			let _rows = this.reportData['rows']
			let _labels = []
			let _tmp = ''
			let _obj = {
				'data': [],
				'backgroundColor': []
			}

			// бежим по всем строкам
			for (let i in _rows)
			{
				// значение
				_tmp = _rows[i][_field]
				// конвертация значения
				if (this.tableColumns && this.tableColumns[_field])
				{
					if (this.tableColumns[_field]['type'] === 'integer') _tmp = parseInt(_tmp)
					else if (this.tableColumns[_field]['type'] === 'float' || this.tableColumns[_field]['type'] === 'money') _tmp = parseFloat(parseFloat(_tmp).toFixed(2))
				}
				// запоминаем значение
				_obj['data'].push(_tmp)

				// цвет
				_obj['backgroundColor'].push('#' + this.Colors[i])

				// вычислим поле для лейбла
				for (let r in _rows[i])
				{
					// по умолчанию - просто берем название поля
					_tmp = r
					// если в нем есть "_name"
					if (r.indexOf('_name') > -1) break
				}

				// запоминаем лейбл
				_labels.push(
					this.localeFtc(_rows[i][_tmp])
				)
			}

			this.pieChartData = {
				'labels': _labels
			}
			this.pieChartData['datasets'] = [_obj]
		},
		//---------------------------------------------------------------------
		// форматирование данных для графика вида "Bar"
		//---------------------------------------------------------------------
		getBarChartData() {
			// ось абсцисс
			let _fieldAbscissa = this.reportData['type']['abscissa']
			let _rows = this.reportData['rows']
			let _labels = []
			let _tmp = ''

			let _columns = this.reportData['type']['columns']
			let _sets = []

			// собираем ось
			for (let i in _rows)
			{
				// значение
				_tmp = _rows[i][_fieldAbscissa]
				// запоминаем
				_labels.push(_tmp)
			}

			// наборы данных
			for (let c in _columns)
			{
				// готовим объект - набор данных
				let _obj = {}
				// наименование поле
				_obj['label'] = this.localeFtc(
					this.tableColumns[_columns[c]] && this.tableColumns[_columns[c]]['title']
						? this.tableColumns[_columns[c]]['title']
						: _columns[c]
				)
				// цвета
				_obj['borderColor'] = '#' + this.Colors[c]
				_obj['backgroundColor'] = '#' + this.Colors[c]
				// данные
				_obj['data'] = []
				for (let i in _rows)
				{
					// значение
					_tmp = _rows[i][_columns[c]]
					// конвертация значения
					if (this.tableColumns && this.tableColumns[_columns[c]])
					{
						if (this.tableColumns[_columns[c]]['type'] === 'integer') _tmp = parseInt(_tmp)
						else if (this.tableColumns[_columns[c]]['type'] === 'float' || this.tableColumns[_columns[c]]['type'] === 'money') _tmp = parseFloat(_tmp)
					}
					// запоминаем
					_obj['data'].push(_tmp)
				}

				// добавляем набор данных в сет
				_sets.push(_obj)
			}

			this.barChartData = {
				'labels': _labels
			}
			this.barChartData['datasets'] = _sets
		},
		//---------------------------------------------------------------------
		// локальная сортировка таблицы - this.tableRows
		//---------------------------------------------------------------------
		sortLocal(row, header, idx) {
			// проверка аргументов
			if (!header) return
			if (!this.tableRows || !this.tableRows.length) return

			// получим название поля по которому требуется сортировка
			let _field = null
			// 0. верхние колонки
			if (row === 0)
			{
				// если нет rowspan - значит это заголовок, по нему не сортируют
				if ('colspan' in header && header['colspan'] > 1) return
				// для верхних колонок поле в объекте
				_field = header.field
				if (!_field) return
			}
			// 1. нижние колонки
			if (row === 1)
			{
				// для нижних колонок поле в объекте
				_field = header.field
				if (!_field) return
			}

			// получим значение сортировки
			let _sortValue = 0
			if (this.sortHeaderIndex.colName === _field) _sortValue = this.sortHeaderIndex.value
			// увеличим его циклически
			_sortValue++
			if (_sortValue > 2) _sortValue = 0

			// начинаем сортировать по выбранному полю
			let _rows = this.tableRows.slice()

			// изменим значение в хранилище
			if (_sortValue)
			{
				// если требуется сортировка
				this.sortHeaderIndex = {
					colName: _field,
					value: _sortValue
				}

				// получим тип поля
				let _type = 'text'
				for (let _prop in this.tableColumns) if (this.tableColumns.hasOwnProperty(_prop))
				{
					let _col = this.tableColumns[_prop]
					if (_col && _col.field === _field)
					{
						_type = _col.type
						break
					}
				}

				let _compareFunc = null
				// определим функцию сравнения в зависимости от типа
				if (_type === 'integer')
				{
					_compareFunc = (a, b) => {
						let _A = parseInt(a[_field], 10)
						let _B = parseInt(b[_field], 10)
						if (isNaN(_A)) _A = 0
						if (isNaN(_B)) _B = 0
						if (_sortValue === 1)
						{
							if (_A < _B) return -1
							if (_A > _B) return 1
						}
						else
						{
							if (_A < _B) return 1
							if (_A > _B) return -1
						}

						return 0
					}
				}
				else if (_type === 'float' || _type === 'money')
				{
					_compareFunc = (a, b) => {
						let _A = parseFloat(a[_field])
						let _B = parseFloat(b[_field])
						if (isNaN(_A)) _A = 0
						if (isNaN(_B)) _B = 0
						if (_sortValue === 1)
						{
							if (_A < _B) return -1
							if (_A > _B) return 1
						}
						else
						{
							if (_A < _B) return 1
							if (_A > _B) return -1
						}

						return 0
					}
				}
				else if (_type === 'date' || _type === 'datetime')
				{
					_compareFunc = (a, b) => {
						let _A = a[_field]
						let _B = b[_field]
						if (_type === 'date')
						{
							_A = _A.split('.').reverse().join('.')
							_B = _B.split('.').reverse().join('.')
						}
						else
						{
							if (/^\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}$/.test(_A))
							{
								_A = new Date(
									_A.substr(6, 4), _A.substr(3, 2) - 1, _A.substr(0, 2),
									_A.substr(11, 2), _A.substr(14, 2)
								)
								_B = new Date(
									_B.substr(6, 4), _B.substr(3, 2) - 1, _B.substr(0, 2),
									_B.substr(11, 2), _B.substr(14, 2)
								)
							}
							else if (/^\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}:\d{2}$/.test(_A))
							{
								_A = new Date(
									_A.substr(6, 4), _A.substr(3, 2) - 1, _A.substr(0, 2),
									_A.substr(11, 2), _A.substr(14, 2), _A.substr(17, 2)
								)
								_B = new Date(
									_B.substr(6, 4), _B.substr(3, 2) - 1, _B.substr(0, 2),
									_B.substr(11, 2), _B.substr(14, 2), _B.substr(17, 2)
								)
							}
						}

						if (_sortValue === 1)
						{
							if (_A < _B) return -1
							if (_A > _B) return 1
						}
						else
						{
							if (_A < _B) return 1
							if (_A > _B) return -1
						}

						return 0
					}
				}
				else if (_type === 'boolean')
				{
					_compareFunc = (a, b) => {
						let _A = Helper.normalizeBooleanValue(a[_field])
						let _B = Helper.normalizeBooleanValue(b[_field])
						if (_sortValue === 1)
						{
							if (_A < _B) return -1
							if (_A > _B) return 1
						}
						else
						{
							if (_A < _B) return 1
							if (_A > _B) return -1
						}

						return 0
					}
				}
				else
				{
					// 'text'
					if (this.id === 'serverresource')
						_compareFunc = Helper.naturalCompareObjectField(_field, _sortValue)
					else
						_compareFunc = (a, b) => {
							if (_sortValue === 1)
							{
								if (a[_field] < b[_field]) return -1
								if (a[_field] > b[_field]) return 1
							}
							else
							{
								if (a[_field] < b[_field]) return 1
								if (a[_field] > b[_field]) return -1
							}

							return 0
						}
				}

				// сортируем по полю в зависимости от значения сортировки
				_rows.sort(_compareFunc)

				// установим значение в хранилище
				this.$set(this, 'tableRows', _rows)
			}
			else
			{
				// если не требуется сортировка
				this.sortHeaderIndex = {
					colName: '',
					value: 0
				}

				// просто сортируем по полю "__rowNo"
				_rows.sort((a, b) => {
					if (a['__rowNo'] < b['__rowNo']) return -1
					if (a['__rowNo'] > b['__rowNo']) return 1

					return 0
				})

				// установим значение в хранилище
				this.$set(this, 'tableRows', _rows)
			}
		},
		//---------------------------------------------------------------------
		// стиль заголовков
		//---------------------------------------------------------------------
		// первый ряд
		headerStyle0(idx) {
			if (this.id === 'account')
			{
				if (idx > 0) return 'width: 85px'
				return false
			}

			if (this.id === 'payment')
			{
				if (idx > 0) return 'width: 285px'
				return false
			}

			if (this.id === 'server')
			{
				if (idx === 1) return 'width: 75px'
				else if (idx > 1) return 'width: 240px'
				return false
			}

			if (this.id === 'servergroup')
			{
				if (idx > 0) return 'width: 240px'
				return false
			}

			if (this.id === 'plangroup')
			{
				if (idx > 0) return 'width: 240px'
				return false
			}

			if (this.id === 'tariff')
			{
				if (idx === 1) return 'width: 60px'
				else if (idx > 1) return 'width: 230px'
				return false
			}

			if (this.id === 'template')
			{
				if (idx === 1) return 'width: 250px'
				else if (idx > 1) return 'width: 50px'
				return false
			}

			if (this.id === 'ticket')
			{
				if (idx === 1) return 'width: 70px'
				else if (idx === 2) return 'width: 250px'
				else if (idx === 3) return 'width: 80px'
				return false
			}

			if (this.id === 'serverresource')
			{
				if (idx === 1) return 'width: 36px'
				else if (idx === 2) return 'width: 120px'
				else if (idx === 3) return 'width: 180px'
				else if (idx === 4 || idx === 5) return 'width: 156px'
				else if (idx === 6) return 'width: 75px'
				else if (idx === 7) return 'width: 280px'
				else if (idx === 8) return 'width: 85px'
			}

			if (this.id === 'vdstop')
			{
				if (this.tableHeader[0].length === 8)
				{
					if (idx === 1) return 'width: 55px'
					if (idx === 3) return 'width: 70px'
					if (idx === 4 || idx === 5 || idx === 6 || idx === 7) return 'width: 140px'
				}
				else
				{
					if (idx === 1) return 'width: 55px'
					if (idx === 2) return 'width: 70px'
					if (idx === 3 || idx === 4 || idx === 5 || idx === 6) return 'width: 140px'
				}
			}

			if (this.id === 'trafftop')
			{
				if (this.tableHeader[0].length === 4)
				{
					if (idx === 1) return 'width: 75px'
					else if (idx === 3) return 'width: 285px'
				}
				else
				{
					if (idx === 1) return 'width: 75px'
					else if (idx === 2) return 'width: 285px'
				}
			}

			if (this.id === 'partnerprogram')
			{
				if (idx === 1) return 'width: 140px'
				else if (idx === 2) return 'width: 90px'
			}

			if (this.id === 'partneraccount')
			{
				if (idx === 0) return 'width: 70px'
				else if (idx === 1) return 'width: 80px'
				else if (idx === 2 || idx === 3) return 'min-width: 150px'
				return false
			}

			if (this.id === 'cephresource')
			{
				if (idx === 1) return 'width: 80px'
				else if (idx === 2) return 'width: 180px'
				else if (idx === 3) return 'width: 270px'
				else if (idx === 4) return 'width: 95px'
				return false
			}

			if (this.id === 'bonus')
			{
				if (idx === 1) return 'width: 140px'
				else if (idx === 2) return 'width: 80px'
				return false
			}

			if (this.id === 'iso')
			{
				if (idx === 1) return 'width: 300px'
				else if (idx === 2) return 'width: 150px'
				else if (idx === 3) return 'width: 150px'
				else if (idx === 4) return 'width: 110px'
				return false
			}

			if (this.id === 'partnertop')
			{
				if (idx === 1) return 'width: 100px'
				else if (idx === 2 || idx === 3) return 'width: 120px'
				return false
			}
		},
		// второй ряд
		headerStyle1(idx) {
			if (this.id === 'partneraccount')
			{
				if (idx === 0) return 'width: 70px'
				else if (idx === 1) return 'width: 100px'
			}

			if (this.id === 'ip')
			{
				if (idx === 0 || idx === 6) return 'width: 70px'
				else return 'width: 50px'
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		filterPeriod,
		filterDate,
		filterSelect,
		chartLine,
		chartPie,
		chartBar,
		chartHorBar
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-chart-table-total {
	font-weight: 500;
	background-color: #f6f6f6;
}

.report-header {
	word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}
.report-header.sort > span {
	border-bottom: 1px dotted #333;
	cursor: pointer;
}

tr.alert-record {
	background-color: #ffefef !important;
    color: #333 !important;
}

tr.alert-record a {
	color: #6dacff !important;
    font-weight: 500 !important;
}

.report-table-wrapper {
	display: inline-block;
	min-width: 1200px;
	overflow: auto;
}

table.report-table > tbody > tr:not(.w5-chart-table-total):not(.empty-table-tr):hover {
	background-color: rgba(255,255,204,0.5) !important;
}

</style>



// WEBPACK FOOTER //
// Report.vue?8db57824